import CustomLayout from '../../components/CustomLayout'
import Profile from '../../components/Profile'
import { callApiFromServer } from '../../helpers/Api';
import { updateCloudinaryUrl } from '../../helpers/Cloudinary';

const ProfilePage = (props) => {
    return (
        <CustomLayout 
            title={props.userData.username}
            description={props.userData.description}
            image={updateCloudinaryUrl(props.userData.profile_picture)}
            showFooter={false}
            showSiderExpanded={true}
            expandSiderInstantly={true}
        >
            <Profile 
                {...props}
            />
        </CustomLayout>
    );
}

export const getServerSideProps = async (ctx) => {
    const {params} = ctx;

    const viewingPublic = true;
    let userData, storyData, followCountData = null;

    if( !params || !params.username) {
        ctx.res.writeHead(302, { Location: '/404' });
        ctx.res.end();
    }

    userData = await callApiFromServer(ctx, '/api/user_account/profile/' + params.username);

    if(!userData || userData.length === 0) {
        ctx.res.writeHead(302, { Location: '/404' });
        ctx.res.end();
    } else {
        storyData = await callApiFromServer(ctx, '/api/story_version/profile/' + userData[0].username)
    }  

    // Pass data to the page via props
    return { props: {viewingPublic, userData: userData[0], storyData}}
}

export default ProfilePage;